import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type DeactivateUserMutationVariables = GraphQLTypes.Exact<{
  deactivateUser: GraphQLTypes.Scalars['String']['input'];
}>;

export type DeactivateUserMutationResult = { __typename?: 'Mutation' } & {
  deactivateUser?: GraphQLTypes.Maybe<
    { __typename?: 'DeactivateUserPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const DeactivateUserDocument = /*#__PURE__*/ gql`
  mutation deactivateUser($deactivateUser: String!) {
    deactivateUser(userId: $deactivateUser) {
      errors {
        message
      }
    }
  }
`;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      deactivateUser: // value for 'deactivateUser'
 *   },
 * });
 */
export function useDeactivateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<DeactivateUserMutationResult, DeactivateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<DeactivateUserMutationResult, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
}
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
